import { render } from "./GhostDraftDataCapturePOC.vue?vue&type=template&id=52baa694&scoped=true&ts=true"
import script from "./GhostDraftDataCapturePOC.vue?vue&type=script&lang=ts"
export * from "./GhostDraftDataCapturePOC.vue?vue&type=script&lang=ts"

import "./GhostDraftDataCapturePOC.vue?vue&type=style&index=0&id=52baa694&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52baa694"],['__file',"src/views/GhostDraftDataCapturePOC.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52baa694"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52baa694', __exports__)) {
    api.reload('52baa694', __exports__)
  }
  
  module.hot.accept("./GhostDraftDataCapturePOC.vue?vue&type=template&id=52baa694&scoped=true&ts=true", () => {
    api.rerender('52baa694', render)
  })

}


export default __exports__